import DocumentDetails from "../GridDataComponent/DocumentDetails";
import "../../CriminalCertificateValidation.css";

const  GenDocument = () =>{
  return(
   <DocumentDetails documentType={'general-documents'} keyAccess={'HawkAI-PAN-V2'} title={'General Document'} exportDataToExcelName={'General Document'} analysefrom={'general-document'} deleteText={'general-document'}modelName={'doc-ai'} webSocketName={'gendocument'}/>
  )
 };
 export default GenDocument;